import React, { useState, useEffect } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import Services from './components/Services';
import ContactForm from './components/ContactForm';
import AboutUs from './components/AboutUs';
import Footer from './components/Footer';
import emailjs from 'emailjs-com'; // make sure this is imported here

function App() {
  const [language, setLanguage] = useState('pt');
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);
  }, []);

  const changeLanguage = (lang) => setLanguage(lang);

  const handleContactClick = () => {
    setActiveSection('contact');
    setTimeout(() => {
      const contact = document.getElementById('contact-section');
      if (contact) {
        contact.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <div className="App">
      <Navbar
        language={language}
        changeLanguage={changeLanguage}
        setActiveSection={setActiveSection}
      />
      <div className="main-content">
        {activeSection === 'home' && (
          <HeroSection language={language} setActiveSection={setActiveSection} />
        )}
        {activeSection === 'services' && (
          <Services
            language={language}
            setActiveSection={setActiveSection}
            onContactClick={handleContactClick}
          />
        )}
        {activeSection === 'contact' && (
          <div className="contact-section" id="contact-section">
            <ContactForm language={language} />
          </div>
        )}
        {activeSection === 'about' && (
          <div className="about-section">
            <AboutUs language={language} setActiveSection={setActiveSection} />
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default App;
